import { render, staticRenderFns } from "./modelWatch.vue?vue&type=template&id=aae81056&scoped=true&"
import script from "./modelWatch.vue?vue&type=script&lang=js&"
export * from "./modelWatch.vue?vue&type=script&lang=js&"
import style0 from "./modelWatch.vue?vue&type=style&index=0&id=aae81056&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae81056",
  null
  
)

export default component.exports